import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { useEffect, useState } from 'react';
import { Row, Col, Typography, Empty, DatePicker, Statistic } from 'antd'
import Box from '../../components/utility/box';
import moment from "moment";
import systemActions from '../../redux/systemInfos/actions';
import { selectDailyStatisticsOfDayFromState } from '../../redux/systemInfos/selectors';

const { Title } = Typography;

const {
  getDailyStatisticsForDay
} = systemActions;

function DailyStatistics(props) {
  const [currentMomentDate, setCurrentMomentDate] = useState(moment().add(-1,'d'));
  const [currentDateStatistics, setCurrentDateStatistics] = useState(undefined);

  useEffect(() => {
    const yesterdaysStatistics = props.selectDailyStatisticsOfDayFromStateFn(currentMomentDate); 
    if (!yesterdaysStatistics) {
      props.getDailyStatisticsForDay(currentMomentDate.format('YYYY-MM-DD'));
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCurrentDateStatistics(props.selectDailyStatisticsOfDayFromStateFn(currentMomentDate))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.dailyStatistics]);

  useEffect(() => {
    const existingStatistics = props.selectDailyStatisticsOfDayFromStateFn(currentMomentDate);
    if (!existingStatistics) props.getDailyStatisticsForDay(currentMomentDate.format('YYYY-MM-DD'));
    else setCurrentDateStatistics(existingStatistics);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentMomentDate]);

  return (
    <Box>
      <Row>
        <Col span={24}>
          <Title level={4} style={{ textAlign: "center" }}>
            <span>Daily statistics  </span>
            <DatePicker allowClear={false} value={currentMomentDate} onChange={(newDate)=>setCurrentMomentDate(newDate)} disabledDate={(currentDate)=> currentDate.isSameOrAfter(moment(), 'D')}/>    
          </Title>
        </Col>
      </Row>
      {currentDateStatistics === undefined && <Empty/>}
      { currentDateStatistics !== undefined && <Row>
        <Col span={12}>
          <Statistic title="Overall activity" value={currentDateStatistics.overallActivity}/>
        </Col>
        <Col span={12}>
          <Statistic title="Successfull logins" value={currentDateStatistics.successfullLogIns}/>
        </Col>
      </Row>}
      { currentDateStatistics !== undefined && <Row>
        <Col span={12}>
          <Statistic title="Unique users logged in" value={currentDateStatistics.uniqueUsersLoggedIn}/>
        </Col>
        <Col span={12}>
          <Statistic title="Unique clinics logged in" value={currentDateStatistics.uniqueClinicsLoggedIn}/>
        </Col>
      </Row>}
    </Box>
  );
}

DailyStatistics.propTypes = {
  day : PropTypes.object,
  getDailyStatisticsForDay: PropTypes.func.isRequired,
  dailyStatistics:PropTypes.array.isRequired,
  selectDailyStatisticsOfDayFromStateFn:PropTypes.func.isRequired
};

DailyStatistics.defaultProps = {
  day: moment()
}

function mapStateToProps(state) {
  return {
    selectDailyStatisticsOfDayFromStateFn: (dayAsMoment) => selectDailyStatisticsOfDayFromState(state, dayAsMoment),
    dailyStatistics: state.SystemInfos.get('dailyStatistics'),
  };
}

const mapActionsToProps = {
  getDailyStatisticsForDay
};

const connectedPage = connect(mapStateToProps, mapActionsToProps)(DailyStatistics);
export default connectedPage;
